import Auth from '@aws-amplify/auth'
import { AuthState } from '@aws-amplify/ui-components'
import { Formik } from 'formik'
import React, { useEffect } from 'react'
import * as Yup from 'yup'

import { useNotification } from 'src/modules/notification'
import { Button, Form, FormikTextField, FIELD_REQUIRED } from 'src/modules/ui'

import FormActions from './FormActions'
import FormHeader from './FormHeader'
import FormLinks from './FormLinks'
import FormLink from './FormLink'

export const VerifyEmailForm = ({
  handleSubmit,
  isSubmitting,
  onClickBackToSignin,
}) => (
  <div>
    <FormHeader
      title="Verify Email Address"
      subtitle="Enter the verification code we just sent to your email address to verify your email address."
    />
    <Form>
      <FormikTextField
        fullWidth
        label="Verification Code"
        margin="normal"
        name="code"
        type="text"
      />
      <FormLinks>
        <FormLink onClick={onClickBackToSignin}>Back To Signin</FormLink>
      </FormLinks>
      <FormActions>
        <Button
          onClick={handleSubmit}
          color="primary"
          isLoading={isSubmitting}
          size="large"
          type="submit"
        >
          Submit Code
        </Button>
      </FormActions>
    </Form>
  </div>
)

const VerifyEmail = ({ onStateChange, user, ...props }) => {
  const { showError, showSuccess } = useNotification()

  const validationSchema = Yup.object().shape({
    code: Yup.string().required(FIELD_REQUIRED),
  })
  const initialValues = { code: '' }

  const handleSubmit = async ({ code }, { setFieldError }) => {
    try {
      await Auth.verifyCurrentUserAttributeSubmit('email', code)
      showSuccess({
        image: 'aubergines',
        message:
          "Welcome to Tried and Supplied. We're here to help!\n\n If you have any questions please contact domini@triedandsupplied.com or contact support from the account menu.",
      })
      onStateChange(AuthState.SignedIn, user)
    } catch (err) {
      if (err.code === 'CodeMismatchException') {
        setFieldError('code', 'Bad code supplied')
      } else {
        showError(err.message)
      }
    }
  }

  const sendCode = async () => {
    try {
      await Auth.verifyCurrentUserAttribute('email')
    } catch (err) {
      if (err.code === 'LimitExceededException') {
        showError(
          'Can not email verification code as requested too many times recently. Please try after some time.'
        )
      } else {
        showError(err.message)
      }
    }
  }

  useEffect(() => {
    sendCode()
  }, [])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {formik => <VerifyEmailForm {...formik} {...props} />}
    </Formik>
  )
}

export default VerifyEmail
